import React from 'react';
import { isEmpty, map } from 'lodash';
import { Link } from 'gatsby';
import { motion } from 'framer-motion';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import BoxedContainer from './layouts/BoxedContainer';

export default function FreeZoneFamilyOfficeBenefits({ id, data }) {
  const { title, text, items, bottomText, link, backgroundImage } = data;
  return (
    <section id={id} className="relative overflow-hidden">
      <BoxedContainer
        className="py-[50px] md:py-[100px] z-10 relative flex flex-col
      gap-y-10 md:gap-y-[50px]">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.4 }}
          viewport={{ once: true }}
          className="flex flex-col gap-y-5 lg:gap-y-[30px]">
          <div className="flex flex-col gap-y-5">
            <div
              dangerouslySetInnerHTML={{ __html: title }}
              className="text-clamp20to40  h2-child:text-clamp20to40 text-white
            h2-child:leading-1.2  text-center h2-child:!m-0"
            />
            <div className="h-[2px] w-[50px] md:w-[70px] bg-white mx-auto" />
          </div>
          <div
            dangerouslySetInnerHTML={{ __html: text }}
            className="p-child:text-white p-child:text-clamp12to18 p-child:font-normal
            p-child:leading-[1.6] p-child:mb-0 p-child:ltr:font-URWDINRegular 
            p-child:rtl:font-GESSTwoDWTCLight text-center"
          />
        </motion.div>
        {isEmpty(items) || (
          <div className="flex flex-row flex-wrap gap-y-8 md:gap-y-[50px] justify-center">
            {map(items, (item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.1 * (index + 1), delay: 0.6 }}
                className="w-full md:w-[33.33%] xl:w-[25%] md:px-10 
                flex flex-col gap-y-4 md:gap-y-5 
                dot-line:last:hidden">
                {isEmpty(item.content.image) || (
                  <div className="w-[67px] h-[67px] md:w-[90px] md:h-[90px] mx-auto flex">
                    <LazyLoadImage
                      src={item.content.image.url}
                      width="100%"
                      effect="blur"
                      placeholderSrc={`${item.content.image}`}
                      className="w-full h-full object-cover"
                    />
                  </div>
                )}
                <div
            dangerouslySetInnerHTML={{ __html: item.content.BenefitsListTitle }}
                  className="text-clamp14to18 text-white [&>*]:text-white ltr:font-URWDINMedium rtl:font-GESSTwoDWTCMedium leading-[1.4]
                text-center m-0 2xl:min-h-[55px]" />
                {/* <div
                  className="w-[5px] h-[5px] bg-white rounded-full mx-auto flex
                sm:hidden dot-line"
                /> */}
              </motion.div>
            ))}
          </div>
        )}
        {isEmpty(bottomText) || (
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.7 }}
          viewport={{ once: true }}
          className="flex flex-col md:flex-row gap-5 md:gap-[50px] justify-center items-center">
          <div
            dangerouslySetInnerHTML={{ __html: bottomText }}
            className="p-child:text-white p-child:text-clamp12to18 p-child:font-normal
            p-child:leading-[1.6] p-child:mb-0 p-child:ltr:font-URWDINRegular p-child:rtl:font-GESSTwoDWTCLight text-center"
          />
          {isEmpty(link) || (
            <div className="flex justify-center">
              <Link
                href={link.url}
                className="w-[170px] flex justify-center items-center rounded-[48px]
              bg-transparent text-white uppercase ltr:font-URWDINBold rtl:font-GESSTwoDWTCMedium ltr:tracking-[1.2px] 
              leading-1 h-[36px] md:h-[49px] text-[11px] md:text-[15px] 
              border-[1px] md:border-[2px] 
              border-white hover:bg-white hover:text-[#CE445B]">
                {link.name}
              </Link>
            </div>
          )}
        </motion.div>
        )}
      </BoxedContainer>
      {isEmpty(backgroundImage) || (
        <div
          className="w-full h-full absolute bottom-0 lazy-load-image:flex
          lazy-load-image:h-full">
          <LazyLoadImage
            src={backgroundImage.url}
            width="100%"
            effect="blur"
            placeholderSrc={`${backgroundImage}`}
            className="w-full h-full object-cover"
          />
        </div>
      )}
    </section>
  );
}
